// Textos de la zona "player". Claves con prefijo "player." (common: sin prefijo fijo).
// Los textos con <b>…</b> / <g>…</g> los pinta en negrita MusicPlayer (ver rich()).
const en = {
  // ── Fuentes de audio (SOURCES en MusicPlayer) ──
  'player.source.tab.label': 'Tab',
  'player.source.tab.btn': 'Capture Tab',
  'player.source.tab.hint': 'Processes audio from another tab (YouTube, Spotify Web…). Chrome, Edge and Brave only.',
  'player.source.mic.label': 'Mic',
  'player.source.mic.btn': 'Enable Mic',
  'player.source.mic.hint': 'Processes whatever comes in through your mic or line input, live.',
  'player.source.file.label': 'File',
  'player.source.file.btn': 'Choose File',
  'player.source.file.hint': 'Load your audio files into the rack Player and play them whenever you like. Works in any browser.',
  'player.source.none.label': 'Just enter',
  'player.source.none.btn': 'Enter',
  'player.source.none.hint': 'Enter without capturing any sound: build the rack and save your setups. Pick a source whenever you like.',

  // ── Errores de captura ──
  'player.err.noMic': 'No microphone detected. Plug one in and try again.',
  'player.err.noTabAudio': 'No audio was shared. Try again and tick the "Share tab audio" box.',
  'player.err.micDenied': 'Microphone permission denied. Allow it in the browser to capture.',
  'player.err.captureDenied': 'Capture permission denied. Try again and accept the dialog.',
  'player.err.startFailed': 'Could not start the processor: {msg}',
  'player.err.rackFull': 'The rack is full and the Player needs a slot. Remove an effect (✕ on its card) and try again.',
  'player.err.badFormat': 'That format can\'t be played. Use MP3, WAV, OGG, M4A, FLAC or WEBM.',
  'player.iaMsg': 'EQ = inverted curve from your test + AI adjustment. You can fine-tune it by hand.',

  // ── Mis configuraciones ──
  'player.cfg.saved': 'Saved "{name}".',
  'player.cfg.saveFailed': 'Could not save the setup. Are you logged in?',
  'player.cfg.applied': 'Setup "{name}" applied.',
  'player.cfg.confirmDelete': 'Delete the setup "{name}"?',
  'player.cfg.deleted': '"{name}" deleted.',
  'player.cfg.deleteFailed': 'Could not delete the setup.',
  'player.cfg.confirmDefault': 'Back to Default? The rack is emptied and everything returns to factory settings. Anything you haven\'t saved will be lost.',
  'player.cfg.defaultDone': 'Default: empty rack and factory settings.',
  'player.cfg.overwritten': '"{name}" saved with the current settings.',
  'player.cfg.renamed': 'Renamed to "{name}".',
  'player.cfg.updateFailed': 'Could not update the setup. Are you logged in?',
  'player.cfg.confirmRestore': 'Restore "{name}" to the original template? Your changes to it will be lost.',
  'player.cfg.restored': '"{name}" restored to the original template.',

  // ── Cabecera, tema y menú de usuario ──
  'player.theme.aria': 'Light mode',
  'player.theme.titleLight': 'Light mode · click to go back to dark',
  'player.theme.titleDark': 'Dark mode · click for light mode',
  'player.menu.profile': 'My profile',
  'player.menu.profileTitle': 'Your details, your email and your password',
  'player.menu.saved': 'Saved audio',
  'player.menu.savedTitle': 'View and download the audio you recorded and saved to your account',
  'player.menu.admin': 'Control panel',
  'player.menu.adminTitle': 'Accounts, activity, audit log and storage (admins only)',
  'player.menu.logout': 'Log Out',
  'player.tagline': 'The sound of the dragon · Live audio processor',
  'player.mode.simple': '⚡ Lite Mode',
  'player.mode.dragon': '🐉 Dragon Mode',
  'player.lite.title': '⚡ Your computer is running tight',
  'player.lite.body': 'The page is only reaching {fps} frames per second. Lite Mode turns off the decorations and leaves the CPU to the sound, so it doesn\'t crackle. You can go back to Dragon Mode whenever you like.',
  'player.lite.accept': 'Turn on Lite Mode',
  'player.lite.never': 'No, thanks',
  'player.lite.later': 'Not now',
  'player.recalibrate': 'Recalibrate Speakers',

  // ── Procesador ──
  'player.processorTitle': 'Audio Processor',
  'player.simple.active': 'Processing audio — optimized mode on',
  'player.simple.idle': '龙  Turn on the processor to begin',
  'player.idle.body': '🐉 Once it\'s on, the <b>effects rack</b>, the <b>sound view</b> and the <b>output volume</b> appear here.',
  'player.idle.file': 'Your audio files load into the rack <b>Player</b>: play them whenever you like.',
  'player.rackTitle': 'Effects rack',
  'player.rackHelp': 'Sound flows through the slots <b>top to bottom (1 → 6)</b>. <b>Drag</b> an effect from the catalog onto a slot, or click an empty slot to pick one. Move them with <g>⣿</g>; to remove one, drop it on the catalog.',
  'player.rackHelpPhone': 'Sound flows through the slots <b>top to bottom (1 → 6)</b>. <b>Tap</b> an empty slot to add an effect, or an effect\'s name to change it. Hold <g>⣿</g> and drag to reorder; <b>✕</b> removes it.',
  'player.master.title': 'Output Fader',
  'player.master.bypassTitle': 'Effects are bypassed. Click to turn them back on.',
  'player.master.help': 'The channel fader, like on a console: the <b>last control before your speakers</b>. It\'s fixed — not a rack effect, and all the sound always goes through here.',
  'player.master.muted': 'Muted (Mute on) — no audio comes out even if you turn the volume up.',
  'player.master.resetTitle': 'Reset to 100 (original)',
  'player.warn.amp': '<b>You are boosting above the original level.</b> There may be distortion, and the sound is louder than your system normally delivers. Take care of your ears and your speakers.',
  'player.warn.danger': '<b>DANGEROUS VOLUME.</b> Listening to music above 85 dB for long periods can cause <b>permanent hearing loss</b>. At this level you can also <b>blow headphones or speakers</b>, and the signal will be heavily distorted (clipping). Use it only for a few seconds and at a reasonable volume on your speakers.',
  'player.tips.tab': '<b>Tab</b>: in the dialog choose <b>"Chrome Tab"</b>, select it and turn on <b>"Share tab audio"</b>. Chrome, Edge and Brave only (not Firefox or Safari).',
  'player.tips.mic': '<b>Mic</b>: accept the browser permission. Processes your voice or instrument live.',
  'player.tips.file': '<b>File</b>: upload an audio file from your computer. Works in any browser and loops until you stop.',
  'player.tips.mute': 'The original tab is <b>muted automatically</b> while you capture (you only hear the dragon\'s version). Pressing <b>Stop</b> restores its sound.',
  'player.tips.fileMobile': '<b>File</b>: pick songs from your phone. They load into the rack <b>Player</b> and play whenever you like.',
  'player.tips.mobileOnly': 'On the phone the dragon processes <b>your songs</b> and <b>your voice</b>. Capturing other apps (Spotify, YouTube) only works on a computer.',

  // ── InputPanel ──
  'player.input.example.tab': 'YouTube, Spotify Web, any page',
  'player.input.example.mic': 'your voice, a guitar, whatever comes in',
  'player.input.example.file': 'your songs from the computer',
  'player.input.example.fileMobile': 'your songs from the phone',
  'player.input.example.none': 'no sound: set up the rack and pick a source later',
  'player.input.antiOnTitle': 'On: clean, no distortion (sounds a bit quieter). Click to go back to the classic sound.',
  'player.input.antiOffTitle': 'Off: classic sound. Turn it on if it sounds crackly or distorted.',
  'player.input.sourceGroup': 'Sound source',
  'player.input.switchTo': 'Switch to {label} without stopping',
  'player.input.antiNoteOn': 'Anti-clipping: clean, no distortion (sounds a bit quieter).',
  'player.input.antiNoteOff': 'Anti-clipping: turn it on if it sounds crackly.',
  'player.input.liveSilent': 'On · no sound',
  'player.input.live': 'Live',
  'player.input.pressOther': '· press another to switch',
  'player.input.label': 'Input · where does the sound come from?',
  'player.input.off': 'Turn off',
  'player.input.on': 'Turn on',
  'player.input.stop': 'Stop',
  'player.input.antiSat': 'Anti-clipping',
  'player.input.monitor': 'Monitor',
  'player.input.monitorOnTitle': 'On: you hear the mic through your speakers or headphones. Click to stop hearing yourself.',
  'player.input.monitorOffTitle': 'Off: the mic is not heard, but the Recorder and meters keep working. Click to hear yourself.',
  'player.input.monitorNoteOff': "Monitor off: you don't hear the mic (it's still recorded).",
  'player.input.latency': 'Latency {ms} ms.',

  // ── Visualizador (SpectrumView + VIZ_MODES) ──
  'player.viz.view': 'View',
  'player.viz.freeze': 'Freeze',
  'player.viz.frozenTitle': 'Frozen: click to make it move again',
  'player.viz.freezeTitle': 'Freeze the image where it is to look at it calmly',
  'player.viz.peak': 'Loudest now',
  'player.viz.bandsTop': 'loudest',
  'player.viz.bandsTitle': 'Each zone adds up the energy of its frequencies: dB = 10·log10(E). 0 dB is the digital maximum; closer to 0 = louder.',
  'player.viz.frozen': '❄ FROZEN',
  'player.zone.low': 'Lows',
  'player.zone.low.hint': 'kick, bass',
  'player.zone.mid': 'Mids',
  'player.zone.mid.hint': 'vocals, guitar',
  'player.zone.high': 'Highs',
  'player.zone.high.hint': 'cymbals, air',
  'player.viz.mode.nebulosa': 'Fire',
  'player.viz.mode.nebulosa.help': 'Lows on the left, highs on the right. Higher = louder.',
  'player.viz.mode.barras': 'Bars',
  'player.viz.mode.barras.help': 'Each bar is a zone of the sound; the little line on top remembers the last peak.',
  'player.viz.mode.puntos': 'Dots',
  'player.viz.mode.puntos.help': 'The classic LED look: the more dots lit, the louder that zone.',
  'player.viz.mode.curva': 'Curve',
  'player.viz.mode.curva.help': 'Slow studio analyzer: the faint line holds the peaks. Hover to see the frequency, the note and what lives there (Freeze to inspect calmly).',
  'player.viz.hover.level': 'level',
  'player.viz.hint.sub': 'Sub: felt more than heard (808, sub-bass)',
  'player.viz.hint.kick': 'Kick punch and bass fundamental',
  'player.viz.hint.body': 'Body: bass, guitars, warmth of the voice',
  'player.viz.hint.mud': 'Mud zone: too much sounds muffled',
  'player.viz.hint.boxy': 'Mids: too much sounds boxy / nasal',
  'player.viz.hint.attack': 'Attack and clarity of voice and guitars',
  'player.viz.hint.presence': 'Presence: the ear is most sensitive here',
  'player.viz.hint.sibilance': 'Definition and sibilance (the S sounds)',
  'player.viz.hint.brilliance': 'Brilliance: cymbals, shine of the voice',
  'player.viz.hint.air': 'Air: the finest sparkle',
  'player.viz.mode.cascada': 'Waterfall',
  'player.viz.mode.cascada.help': 'Sound falls like a waterfall: the present at the top, what already passed below.',
  'player.viz.mode.onda': 'Wave',
  'player.viz.mode.onda.help': 'The waveform: how the sound vibrates from one instant to the next.',

  // ── Perilla de volumen ──
  'player.knob.zone.danger': 'DANGER',
  'player.knob.zone.amp': 'BOOSTED',
  'player.knob.zone.original': 'ORIGINAL',
  'player.knob.zone.normal': 'NORMAL',
  'player.knob.aria': 'Master volume',
  'player.knob.bgAlt': 'Dragon dial',
  'player.knob.knobAlt': 'Volume knob',
  'player.knob.help': 'Turn the knob (drag or use the wheel)',
  'player.knob.normal': '0–100 normal',
  'player.knob.amp': '100–600 boosted (red zone)',

  // ── Ecualizador gráfico ──
  'player.geq.alt': 'Dragon equalizer',
  'player.geq.reset': 'Reset {band} to 0 dB',
  'player.geq.band': '{band} band',
  'player.geq.valueText': '{gain} decibels',
  'player.geq.title': '{band} · {gain} dB (drag, wheel or arrows)',

  // ── Presets temáticos del EQ (data/eqPresets.js) ──
  'player.presetCat.all': 'All',
  'player.presetCat.reference': 'Reference',
  'player.presetCat.voice': 'Voice',
  'player.presetCat.electronic': 'Electronic',
  'player.presetCat.music': 'Music',
  'player.presetCat.gaming': 'Gaming',
  'player.presetCat.style': 'Style',
  'player.preset.harman_neutral': 'Balanced, natural sound (Harman curve).',
  'player.preset.harman_warm': 'Warm, relaxed listening with little fatigue.',
  'player.preset.harman_bright': 'Maximum clarity and detail.',
  'player.preset.vocal_clarity': 'Improves vocal intelligibility.',
  'player.preset.podcast_studio': 'Broadcast/radio-style voice.',
  'player.preset.edm_festival': 'Festival sound: powerful lows and bright highs.',
  'player.preset.edm_club': 'Club-style bass pressure.',
  'player.preset.deep_bass': 'Maximum bass and sub-bass impact.',
  'player.preset.hiphop_modern': 'Modern rap: 808s, punch and vocal presence.',
  'player.preset.trap': 'Deep lows with crisp vocals.',
  'player.preset.rock_classic': 'Brings out guitars and live instruments.',
  'player.preset.metal': 'Aggressive, detailed playback.',
  'player.preset.pop_commercial': 'Modern, polished, exciting sound.',
  'player.preset.jazz': 'Natural, realistic timbre.',
  'player.preset.classical': 'Neutral orchestral playback.',
  'player.preset.gaming_fps': 'Footsteps and directional awareness.',
  'player.preset.gaming_cinematic': 'Immersive, emotional experience.',
  'player.preset.relax_chill': 'Fatigue-free listening, maximum comfort.',
  'player.preset.studio_monitor': 'Mix analysis, transparency.',
  'player.preset.mastering_reference': 'Critical mastering evaluation.',
  'player.presetTag.allGenres': 'All genres',
  'player.presetTag.dailyUse': 'Everyday use',
  'player.presetTag.jazz': 'Jazz',
  'player.presetTag.acoustic': 'Acoustic',
  'player.presetTag.longSessions': 'Long sessions',
  'player.presetTag.criticalListening': 'Critical listening',
  'player.presetTag.classical': 'Classical',
  'player.presetTag.podcasts': 'Podcasts',
  'player.presetTag.vocals': 'Vocals',
  'player.presetTag.meetings': 'Meetings',
  'player.presetTag.audiobooks': 'Audiobooks',
  'player.presetTag.edm': 'EDM',
  'player.presetTag.house': 'House',
  'player.presetTag.techno': 'Techno',
  'player.presetTag.dance': 'Dance',
  'player.presetTag.bass': 'Bass',
  'player.presetTag.dubstep': 'Dubstep',
  'player.presetTag.trap': 'Trap',
  'player.presetTag.hiphop': 'Hip-Hop',
  'player.presetTag.rap': 'Rap',
  'player.presetTag.urban': 'Urban',
  'player.presetTag.drill': 'Drill',
  'player.presetTag.rock': 'Rock',
  'player.presetTag.classicRock': 'Classic Rock',
  'player.presetTag.metal': 'Metal',
  'player.presetTag.hardRock': 'Hard Rock',
  'player.presetTag.pop': 'Pop',
  'player.presetTag.top40': 'Top 40',
  'player.presetTag.orchestra': 'Orchestra',
  'player.presetTag.fps': 'FPS',
  'player.presetTag.competitive': 'Competitive',
  'player.presetTag.rpg': 'RPG',
  'player.presetTag.adventure': 'Adventure',
  'player.presetTag.movies': 'Movies',
  'player.presetTag.lofi': 'LoFi',
  'player.presetTag.ambient': 'Ambient',
  'player.presetTag.study': 'Study',
  'player.presetTag.mixing': 'Mixing',
  'player.presetTag.analysis': 'Analysis',
  'player.presetTag.mastering': 'Mastering',
  'player.presetTag.finalReview': 'Final review',
};

const es = {
  // ── Fuentes de audio (SOURCES en MusicPlayer) ──
  'player.source.tab.label': 'Pestaña',
  'player.source.tab.btn': 'Capturar Pestaña',
  'player.source.tab.hint': 'Procesa el audio de otra pestaña (YouTube, Spotify Web…). Solo Chrome, Edge y Brave.',
  'player.source.mic.label': 'Micrófono',
  'player.source.mic.btn': 'Activar Micrófono',
  'player.source.mic.hint': 'Procesa en vivo lo que entra por tu micrófono o entrada de línea.',
  'player.source.file.label': 'Archivo',
  'player.source.file.btn': 'Elegir Archivo',
  'player.source.file.hint': 'Carga tus audios en el Reproductor del rack y suénalos cuando quieras. Funciona en cualquier navegador.',
  'player.source.none.label': 'Solo entrar',
  'player.source.none.btn': 'Entrar',
  'player.source.none.hint': 'Entra sin captar ningún sonido: arma el rack y guarda tus configuraciones. Elige una fuente cuando quieras.',

  // ── Errores de captura ──
  'player.err.noMic': 'No se detectó ningún micrófono. Conecta uno y vuelve a intentarlo.',
  'player.err.noTabAudio': 'No se compartió audio. Vuelve a intentarlo y marca la casilla "Compartir audio de la pestaña".',
  'player.err.micDenied': 'Permiso de micrófono denegado. Acéptalo en el navegador para capturar.',
  'player.err.captureDenied': 'Permiso de captura denegado. Vuelve a intentarlo y acepta el diálogo.',
  'player.err.startFailed': 'No se pudo iniciar el procesador: {msg}',
  'player.err.rackFull': 'El rack está lleno y el Reproductor necesita un slot. Quita un efecto (✕ en su tarjeta) y vuelve a intentarlo.',
  'player.err.badFormat': 'Ese formato no se puede reproducir. Usa MP3, WAV, OGG, M4A, FLAC o WEBM.',
  'player.iaMsg': 'EQ = curva invertida de tu test + ajuste de la IA. Puedes afinarlo a mano.',

  // ── Mis configuraciones ──
  'player.cfg.saved': 'Guardada "{name}".',
  'player.cfg.saveFailed': 'No se pudo guardar la configuración. ¿Iniciaste sesión?',
  'player.cfg.applied': 'Configuración "{name}" aplicada.',
  'player.cfg.confirmDelete': '¿Borrar la configuración "{name}"?',
  'player.cfg.deleted': '"{name}" borrada.',
  'player.cfg.deleteFailed': 'No se pudo borrar la configuración.',
  'player.cfg.confirmDefault': '¿Volver a Default? Se vacía el rack y todo vuelve a como viene de fábrica. Lo que no hayas guardado se pierde.',
  'player.cfg.defaultDone': 'Default: rack vacío y todo de fábrica.',
  'player.cfg.overwritten': '"{name}" guardada con los ajustes actuales.',
  'player.cfg.renamed': 'Renombrada a "{name}".',
  'player.cfg.updateFailed': 'No se pudo actualizar la configuración. ¿Iniciaste sesión?',
  'player.cfg.confirmRestore': '¿Restaurar "{name}" a la plantilla original? Se pierden tus cambios en ella.',
  'player.cfg.restored': '"{name}" restaurada a la plantilla original.',

  // ── Cabecera, tema y menú de usuario ──
  'player.theme.aria': 'Modo claro',
  'player.theme.titleLight': 'Modo claro · pulsa para volver al oscuro',
  'player.theme.titleDark': 'Modo oscuro · pulsa para el modo claro',
  'player.menu.profile': 'Mi perfil',
  'player.menu.profileTitle': 'Tus datos, tu correo y tu contraseña',
  'player.menu.saved': 'Audios guardados',
  'player.menu.savedTitle': 'Ver y descargar los audios que grabaste y guardaste en tu cuenta',
  'player.menu.admin': 'Panel de control',
  'player.menu.adminTitle': 'Cuentas, actividad, bitácora y almacenamiento (solo admins)',
  'player.menu.logout': 'Cerrar Sesión',
  'player.tagline': 'El sonido del dragón · Procesador de audio en vivo',
  'player.mode.simple': '⚡ Modo Ligero',
  'player.mode.dragon': '🐉 Modo Dragón',
  'player.lite.title': '⚡ Tu equipo va justo',
  'player.lite.body': 'La página solo llega a {fps} cuadros por segundo. El Modo Ligero apaga los adornos y deja la CPU para el sonido, así no cruje. Puedes volver al Modo Dragón cuando quieras.',
  'player.lite.accept': 'Activar Modo Ligero',
  'player.lite.never': 'No, gracias',
  'player.lite.later': 'Ahora no',
  'player.recalibrate': 'Recalibrar Parlantes',

  // ── Procesador ──
  'player.processorTitle': 'Procesador de Audio',
  'player.simple.active': 'Procesando audio — modo optimizado activo',
  'player.simple.idle': '龙  Activa el procesador para comenzar',
  'player.idle.body': '🐉 Al encender aparecen aquí el <b>rack de efectos</b>, la <b>vista del sonido</b> y el <b>volumen de salida</b>.',
  'player.idle.file': 'Tus audios se cargan en el <b>Reproductor</b> del rack: los suenas cuando quieras.',
  'player.rackTitle': 'Rack de efectos',
  'player.rackHelp': 'El sonido pasa por los espacios <b>de arriba abajo (1 → 6)</b>. <b>Arrastra</b> un efecto del catálogo a un espacio, o pulsa un espacio libre para elegirlo. Muévelos con <g>⣿</g>; para quitar uno, suéltalo en el catálogo.',
  'player.rackHelpPhone': 'El sonido pasa por los espacios <b>de arriba abajo (1 → 6)</b>. <b>Toca</b> un espacio libre para poner un efecto, o el nombre de uno para cambiarlo. Mantén <g>⣿</g> y arrastra para reordenar; <b>✕</b> lo quita.',
  'player.master.title': 'Fader de Salida',
  'player.master.bypassTitle': 'Los efectos están en bypass. Pulsa para volver a activarlos.',
  'player.master.help': 'El fader del canal, como en una consola: el <b>último control antes de tus parlantes</b>. Es fijo — no es un efecto del rack y todo el sonido pasa siempre por aquí.',
  'player.master.muted': 'Silenciado (Mute activo) — no sale audio aunque subas el volumen.',
  'player.master.resetTitle': 'Restablecer a 100 (original)',
  'player.warn.amp': '<b>Estás amplificando por encima del nivel original.</b> Puede haber distorsión y el sonido es más fuerte de lo que tu sistema entrega normalmente. Cuida tus oídos y tus parlantes.',
  'player.warn.danger': '<b>VOLUMEN PELIGROSO.</b> Escuchar música por encima de 85 dB durante períodos prolongados puede causar <b>pérdida auditiva permanente</b>. A este nivel también puedes <b>quemar audífonos o parlantes</b> y la señal va a estar fuertemente distorsionada (clipping). Úsalo solo unos segundos y a volumen razonable en tus altavoces.',
  'player.tips.tab': '<b>Pestaña</b>: en el diálogo elige <b>"Pestaña de Chrome"</b>, selecciónala y activa <b>"Compartir audio de la pestaña"</b>. Solo Chrome, Edge y Brave (no Firefox ni Safari).',
  'player.tips.mic': '<b>Micrófono</b>: acepta el permiso del navegador. Procesa en vivo tu voz o instrumento.',
  'player.tips.file': '<b>Archivo</b>: sube un audio de tu equipo. Funciona en cualquier navegador y suena en bucle hasta que detienes.',
  'player.tips.mute': 'La pestaña original se <b>silencia sola</b> mientras capturas (oyes solo la versión del dragón). Al pulsar <b>Detener</b> recupera su sonido.',
  'player.tips.fileMobile': '<b>Archivo</b>: elige canciones de tu celular. Se cargan en el <b>Reproductor</b> del rack y las suenas cuando quieras.',
  'player.tips.mobileOnly': 'En el celular el dragón procesa <b>tus canciones</b> y <b>tu voz</b>. Capturar otras apps (Spotify, YouTube) solo se puede en computador.',

  // ── InputPanel ──
  'player.input.example.tab': 'YouTube, Spotify Web, cualquier página',
  'player.input.example.mic': 'tu voz, una guitarra, lo que entre',
  'player.input.example.file': 'tus canciones del computador',
  'player.input.example.fileMobile': 'tus canciones del celular',
  'player.input.example.none': 'sin sonido: preparas el rack y eliges fuente después',
  'player.input.antiOnTitle': 'Encendido: limpio y sin distorsión (suena un poco más bajo). Pulsa para volver al sonido clásico.',
  'player.input.antiOffTitle': 'Apagado: sonido clásico. Enciéndelo si suena rajado o distorsionado.',
  'player.input.sourceGroup': 'Fuente del sonido',
  'player.input.switchTo': 'Cambiar a {label} sin apagar',
  'player.input.antiNoteOn': 'Anti-saturación: limpio y sin distorsión (suena un poco más bajo).',
  'player.input.antiNoteOff': 'Anti-saturación: enciéndelo si suena rajado.',
  'player.input.liveSilent': 'Encendido · sin sonido',
  'player.input.live': 'En vivo',
  'player.input.pressOther': '· pulsa otra para cambiar',
  'player.input.label': 'Entrada · ¿de dónde viene el sonido?',
  'player.input.off': 'Apagar',
  'player.input.on': 'Encender',
  'player.input.stop': 'Detener',
  'player.input.antiSat': 'Anti-saturación',
  'player.input.monitor': 'Monitor',
  'player.input.monitorOnTitle': 'Encendido: oyes el micrófono por tus parlantes o audífonos. Pulsa para dejar de oírte.',
  'player.input.monitorOffTitle': 'Apagado: el micrófono no suena, pero la Grabadora y los medidores siguen funcionando. Pulsa para oírte.',
  'player.input.monitorNoteOff': 'Monitor apagado: no oyes el micrófono (sí se graba).',
  'player.input.latency': 'Retardo {ms} ms.',

  // ── Visualizador (SpectrumView + VIZ_MODES) ──
  'player.viz.view': 'Vista',
  'player.viz.freeze': 'Freeze',
  'player.viz.frozenTitle': 'Congelado: pulsa para que vuelva a moverse',
  'player.viz.freezeTitle': 'Congela la imagen donde está para mirarla con calma',
  'player.viz.peak': 'Lo que más suena',
  'player.viz.bandsTop': 'más fuerte',
  'player.viz.bandsTitle': 'Cada zona suma la energía de sus frecuencias: dB = 10·log10(E). 0 dB es el máximo digital; más cerca de 0 = suena más fuerte.',
  'player.viz.frozen': '❄ CONGELADO',
  'player.zone.low': 'Graves',
  'player.zone.low.hint': 'bombo, bajo',
  'player.zone.mid': 'Medios',
  'player.zone.mid.hint': 'voz, guitarra',
  'player.zone.high': 'Agudos',
  'player.zone.high.hint': 'platillos, brillo',
  'player.viz.mode.nebulosa': 'Fuego',
  'player.viz.mode.nebulosa.help': 'Graves a la izquierda, agudos a la derecha. Más alto = suena más fuerte.',
  'player.viz.mode.barras': 'Barras',
  'player.viz.mode.barras.help': 'Cada barra es una zona del sonido; la rayita de arriba recuerda el último pico.',
  'player.viz.mode.puntos': 'Puntos',
  'player.viz.mode.puntos.help': 'El clásico de luces: cuantos más puntos encendidos, más fuerte suena esa zona.',
  'player.viz.mode.curva': 'Curva',
  'player.viz.mode.curva.help': 'Analizador de estudio lento: la línea tenue guarda los picos. Pasa el ratón para ver la frecuencia, la nota y qué vive ahí (Freeze para mirarlo con calma).',
  'player.viz.hover.level': 'nivel',
  'player.viz.hint.sub': 'Sub: se siente más que se oye (808, sub-bajo)',
  'player.viz.hint.kick': 'Golpe del bombo y fundamental del bajo',
  'player.viz.hint.body': 'Cuerpo: bajo, guitarras, calidez de la voz',
  'player.viz.hint.mud': 'Zona de barro: si sobra, suena tapado',
  'player.viz.hint.boxy': 'Medios: si sobra, suena a caja / nasal',
  'player.viz.hint.attack': 'Ataque y claridad de voz y guitarras',
  'player.viz.hint.presence': 'Presencia: aquí el oído es más sensible',
  'player.viz.hint.sibilance': 'Definición y sibilancia (las eses)',
  'player.viz.hint.brilliance': 'Brillo: platillos, chispa de la voz',
  'player.viz.hint.air': 'Aire: el destello más fino',
  'player.viz.mode.cascada': 'Cascada',
  'player.viz.mode.cascada.help': 'El sonido cae como una cascada: arriba lo de ahora, abajo lo que ya pasó.',
  'player.viz.mode.onda': 'Onda',
  'player.viz.mode.onda.help': 'La forma de la onda: cómo vibra el sonido de un instante a otro.',

  // ── Perilla de volumen ──
  'player.knob.zone.danger': 'PELIGROSO',
  'player.knob.zone.amp': 'AMPLIFICADO',
  'player.knob.zone.original': 'ORIGINAL',
  'player.knob.zone.normal': 'NORMAL',
  'player.knob.aria': 'Volumen master',
  'player.knob.bgAlt': 'Dial dragón',
  'player.knob.knobAlt': 'Perilla de volumen',
  'player.knob.help': 'Gira la perilla (arrastra o usa la rueda)',
  'player.knob.normal': '0–100 normal',
  'player.knob.amp': '100–600 amplificado (zona roja)',

  // ── Ecualizador gráfico ──
  'player.geq.alt': 'Ecualizador dragón',
  'player.geq.reset': 'Restablecer {band} a 0 dB',
  'player.geq.band': 'Banda {band}',
  'player.geq.valueText': '{gain} decibelios',
  'player.geq.title': '{band} · {gain} dB (arrastra, rueda o flechas)',

  // ── Presets temáticos del EQ (data/eqPresets.js) ──
  'player.presetCat.all': 'Todas',
  'player.presetCat.reference': 'Referencia',
  'player.presetCat.voice': 'Voz',
  'player.presetCat.electronic': 'Electrónica',
  'player.presetCat.music': 'Música',
  'player.presetCat.gaming': 'Gaming',
  'player.presetCat.style': 'Estilo',
  'player.preset.harman_neutral': 'Sonido equilibrado y natural (curva Harman).',
  'player.preset.harman_warm': 'Escucha cálida y relajada, poca fatiga.',
  'player.preset.harman_bright': 'Máxima claridad y detalle.',
  'player.preset.vocal_clarity': 'Mejora la inteligibilidad de la voz.',
  'player.preset.podcast_studio': 'Voz estilo locución/radio.',
  'player.preset.edm_festival': 'Sonido de festival: graves potentes y agudos brillantes.',
  'player.preset.edm_club': 'Presión de graves estilo discoteca.',
  'player.preset.deep_bass': 'Máximo impacto de graves y sub-graves.',
  'player.preset.hiphop_modern': 'Rap moderno: 808s, pegada y presencia vocal.',
  'player.preset.trap': 'Graves profundos con voces nítidas.',
  'player.preset.rock_classic': 'Realza guitarras e instrumentos en vivo.',
  'player.preset.metal': 'Reproducción agresiva y detallada.',
  'player.preset.pop_commercial': 'Sonido moderno, pulido y emocionante.',
  'player.preset.jazz': 'Timbre natural y realista.',
  'player.preset.classical': 'Reproducción orquestal neutra.',
  'player.preset.gaming_fps': 'Pasos y conciencia direccional.',
  'player.preset.gaming_cinematic': 'Experiencia inmersiva y emocional.',
  'player.preset.relax_chill': 'Escucha sin fatiga, máximo confort.',
  'player.preset.studio_monitor': 'Análisis de mezcla, transparencia.',
  'player.preset.mastering_reference': 'Evaluación crítica de masterización.',
  'player.presetTag.allGenres': 'Todo género',
  'player.presetTag.dailyUse': 'Uso diario',
  'player.presetTag.jazz': 'Jazz',
  'player.presetTag.acoustic': 'Acústico',
  'player.presetTag.longSessions': 'Sesiones largas',
  'player.presetTag.criticalListening': 'Escucha crítica',
  'player.presetTag.classical': 'Clásica',
  'player.presetTag.podcasts': 'Podcasts',
  'player.presetTag.vocals': 'Voces',
  'player.presetTag.meetings': 'Reuniones',
  'player.presetTag.audiobooks': 'Audiolibros',
  'player.presetTag.edm': 'EDM',
  'player.presetTag.house': 'House',
  'player.presetTag.techno': 'Techno',
  'player.presetTag.dance': 'Dance',
  'player.presetTag.bass': 'Bass',
  'player.presetTag.dubstep': 'Dubstep',
  'player.presetTag.trap': 'Trap',
  'player.presetTag.hiphop': 'Hip-Hop',
  'player.presetTag.rap': 'Rap',
  'player.presetTag.urban': 'Urbano',
  'player.presetTag.drill': 'Drill',
  'player.presetTag.rock': 'Rock',
  'player.presetTag.classicRock': 'Classic Rock',
  'player.presetTag.metal': 'Metal',
  'player.presetTag.hardRock': 'Hard Rock',
  'player.presetTag.pop': 'Pop',
  'player.presetTag.top40': 'Top 40',
  'player.presetTag.orchestra': 'Orquesta',
  'player.presetTag.fps': 'FPS',
  'player.presetTag.competitive': 'Competitivo',
  'player.presetTag.rpg': 'RPG',
  'player.presetTag.adventure': 'Aventura',
  'player.presetTag.movies': 'Películas',
  'player.presetTag.lofi': 'LoFi',
  'player.presetTag.ambient': 'Ambient',
  'player.presetTag.study': 'Estudio',
  'player.presetTag.mixing': 'Mezcla',
  'player.presetTag.analysis': 'Análisis',
  'player.presetTag.mastering': 'Masterización',
  'player.presetTag.finalReview': 'Revisión final',
};

const player = { en, es };
export default player;
